module.exports = __webpack_public_path__ + "static/confidential-65820b926ee458f0ecc6b9a2dfbfa769.png";